import { useFormat } from '@ideavivat/vivat-2';

export const target_date = {
  name: 'วันที่เป้าหมาย',
  width: '6rem',
  class: 'text-right',
  // eslint-disable-next-line
  filter: (val: string) => val ? useFormat.date(val).displayShortThaiDate() : '',
};

export const purchase_unit = {
  name: 'หน่วยสั่งซื้อ',
  width: '5rem',
  class: 'text-left',
  // eslint-disable-next-line
  filter: (val: string) => val ? val : '-',
};

export const purchase_request = {
  name: 'รหัส PR',
  width: '6rem',
  class: 'text-left',
  filter: (val: any) => val?.code || '',
};

export const materialBrand = {
  name: 'Material / Brand',
  width: '10rem',
  filter: (val: string, row: any) => row.item.material?.brand || row.item.material.name,
};

export const bom_item = {
  name: 'เลขที่งาน',
  width: '8rem',
  filter: (val: string, row: any) => row.item.bom_item?.job_no || '',
};

export const materialCode = {
  name: 'รหัสชิ้นส่วน',
  width: '1.2fr',
  filter: (val: string, row: { item: { [key: string]: any }; index: number }) => {
    if (row.item.bom_item?.production_type === 'FAB') return row.item.bom_item?.drawing_no;
    return row.item.material?.code || '';
  },
};

export const type = {
  name: 'ประเภท',
  width: '4rem',
  filter: (val: string, row: any) => row.item.bom_item?.production_type || '',
};

export const price_per_unit = {
  name: 'ราคา/หน่วย',
  width: '5rem',
  class: 'text-right',
  filter: (val: string, row: any) => `${parseFloat(val || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`,
};

export const total_price = {
  name: 'ราคารวม',
  width: '7rem',
  class: 'text-right',
  filter: (val: string, row: any) => `${parseFloat(val || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`,
};
